import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';

import { expValEquals } from '@confluence/feature-experiments';
import { useQueryNoFurtherUpdateInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryNoFurtherUpdateInterop.ts';
import { WebPanelLocationQuery } from './WebPanelLocationQuery.graphql.ts';
import type {
	WebPanelLocationQuery as WebPanelLocationQueryType,
	WebPanelLocationQueryVariables as WebPanelLocationQueryVariablesType,
} from './__types__/WebPanelLocationQuery.ts';

export const useConnectAppsData = ({
	contentId,
	location,
}: {
	contentId: string;
	location: string;
}) => {
	const baseOptions = {
		variables: {
			contentId,
			location,
		},
	};

	// eslint-disable-next-line graphql-client-usage/graphql-generic-types
	const { data } = expValEquals('confluence_stop_watching_webpanellocationquery', 'isEnabled', true)
		? // eslint-disable-next-line react-hooks/rules-of-hooks
			useQueryNoFurtherUpdateInterop<WebPanelLocationQueryType, WebPanelLocationQueryVariablesType>(
				WebPanelLocationQuery,
				baseOptions,
			)
		: // eslint-disable-next-line react-hooks/rules-of-hooks
			useQuery<WebPanelLocationQueryType, WebPanelLocationQueryVariablesType>(
				// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
				WebPanelLocationQuery,
				{
					...baseOptions,
					fetchPolicy: 'cache-first',
				},
			);
	const panels = data?.webPanels || [];
	return panels.map((panel) => panel?.moduleKey).join(',');
};
